import type { Router, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { ElLoading } from 'element-plus'
import { getMenuByLoginAccount } from '@/request/api/userCenter/userCenter';
import { addRoute } from '@/util/class/route/route';
import { routes } from "@/router/route/base";
import { whiteList } from '@u/class/common'
export const routerPermission = (router: Router) => {
    router.beforeEach( async (to, from, next) => {
        if(whiteList.includes(to.name as string)) {
            next()
            return;
        }
        console.log(store.state.accessToken)
        if(store.state.accessToken) {
            if(!store.state.isGetInfo) {
                const loadingInstance = ElLoading.service({ fullscreen: true })
                try {
                    await store.dispatch('getUserInfo')
                    await store.dispatch('getMenu');    //生成路由
                    store.commit('setIsGetInfo', true)
                    loadingInstance.close()

                    next({
                        ...to,
                        replace: true
                    });
                } catch (err) {
                    console.log(err)
                    loadingInstance.close();
                }
                
                
                
            }else {
                next()
            }
        }else {
            if(to.name == 'login') {
                next()
            }else {
                next({
                    name: 'login'
                })
            }
            
        }
        
    })
    
}